// src/pages/pricingUnits/CreatePricingUnit.jsx

import React from "react";
import { useNavigate } from "react-router-dom";

import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import WrapperSection from "../../components/global/WrapperSection";
import FormAddEditPricingUnits from "../../components/pricingUnits/FormAddEditPricingUnits";

const CreatePricingUnit = () => {
    const navigate = useNavigate();

    const handleSuccess = () => {
        navigate("/pricing-units");
    };

    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <FormAddEditPricingUnits
                isEdit={false}
                currentData={null}
                onSubmitSuccess={handleSuccess}
            />
        </WrapperSection>
    );
};

export default CreatePricingUnit;
